export default {
      id: "unit_type_trailer-usage",
      viewBox: "0 0 38 19",
      url: __webpack_public_path__ + "img/icons.svg#unit_type_trailer",
      toString: function () {
        return this.url;
      }
    }